// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".site-footer_contact-list{display:flex;flex-wrap:wrap;grid-row-gap:16px;row-gap:16px;margin:0 0 16px;padding:0;list-style:none}@media(max-width:991px){.site-footer_contact-list{display:block}}.site-footer_contact-list-item{flex:0 0 100%;width:100%;margin-bottom:12px}.site-footer_contact-list-item:first-child{grid-row:span 2}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
